import { Customer } from "../../Types";
import "./index.css"

type Props = {
  customer: Customer;
};

export default function CustomerView({ customer }: Props) {
  return (
    <div className="customer-view">
      <table>
        <tbody>
        <tr>
          <td style={{animationDelay: "0s"}}>
            <label>Förnamn</label>
            <p>{customer.firstName}</p>
          </td>
          <td style={{animationDelay: "0.05s"}}>
            <label>Efternamn</label>
            <p>{customer.lastName}</p>
          </td>
          <td style={{animationDelay: "0.1s"}}>
            <label>Kundnummer</label>
            <p>{customer.id}</p>
          </td>
        </tr>
        <tr>
        <td style={{animationDelay: "0.15s"}}>
            <label>Adress</label>
            <p style={{textTransform: "capitalize"}}>{customer.adress.toLowerCase()}</p>
          </td>
          <td style={{animationDelay: "0.2s"}}>
            <label>Postnummer</label>
            <p>{customer.zipCode}</p>
          </td>
          <td style={{animationDelay: "0.25s"}}>
            <label>Stad</label>
            <p>{customer.city}</p>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}
